/* import __COLOCATED_TEMPLATE__ from './volts-kickback-overlay.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import PrettyNum from '../utils/pretty-num-wrapper';

export default class VoltsKickbackOverlay extends Component {
    tagName = '';
    inVoltsKickback = null;

    @computed('inVoltsKickback') get voltsKickback() {
        return PrettyNum.eng3(this.inVoltsKickback, { scale: 0 });
    }
}
